import { FC, useCallback } from 'react';
import { useAppDispatch } from 'hooks/redux';
import { useNavigate } from 'react-router';
import * as routes from 'router/Routes';
import { SortOrder } from 'utils/array';
import SortableTable, { HeaderCell } from 'components/UI/Table/SortableTable';
import { Service } from 'models/husqiotbus';
import { fetchConfigDetails } from 'store/husqiotbusState/husqiotbusState';

const headerCells: HeaderCell[] = [
  {
    title: 'husqiotbus.service_name',
    sortable: true,
  },
  {
    title: 'husqiotbus.service_type',
    sortable: true,
  },
  {
    title: 'husqiotbus.contact_email',
    sortable: true,
  },
];

type Props = {
  services: Service[];
};

const ConfigTable: FC<Props> = ({ services }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  // Fetch devices and navigate
  const onClick = useCallback(
    (name: string) => {
      if (name) {
        dispatch(fetchConfigDetails(name));
      }
      navigate(`${routes.HUSQIOTBUS}/${name}`);
    },
    [dispatch, navigate]
  );

  // Table rows
  const bodyRows = services.map((service) => {
    return {
      name: service.name,
      type: service.type,
      email: service.contactEmail,
      link: service.name,
    };
  });

  return (
    <SortableTable
      headerCells={headerCells}
      bodyRows={bodyRows}
      onClick={onClick}
      sortOrder={SortOrder.Asc}
      sortIndex={0}
    />
  );
};

export default ConfigTable;
